import {
  CLIENTES_GET_CLIENTE_BEGIN,
  CLIENTES_GET_CLIENTE_SUCCESS,
  CLIENTES_GET_CLIENTE_FAILURE,
  CLIENTES_GET_CLIENTE_DISMISS_ERROR,
} from './constants';
import { BFFAgent } from 'BFFAgent';

export function getCliente(args = {}) {
    return async dispatch => {
        
        dispatch({
            type: CLIENTES_GET_CLIENTE_BEGIN
        })

        const { idCliente } = args
        try {
            const response = await BFFAgent.Clients.getCliente(idCliente)

            dispatch({
                type: CLIENTES_GET_CLIENTE_SUCCESS,
                data: response
            })
        } catch (err) {
            dispatch({
                type: CLIENTES_GET_CLIENTE_FAILURE,
                data: {
                    error: err?.data?.message || err.message || 'Error al obtener cliente'
                }
            })
        }
    }
}

export function dismissGetClienteError() {
  return {
    type: CLIENTES_GET_CLIENTE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CLIENTES_GET_CLIENTE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        getClientePending: true,
        getClienteError: null,
      };

    case CLIENTES_GET_CLIENTE_SUCCESS:
      // The request is success
      return {
        ...state,
        selectedClient: action.data,
        getClientePending: false,
        getClienteError: null,
      };

    case CLIENTES_GET_CLIENTE_FAILURE:
      // The request is failed
      return {
        ...state,
        getClientePending: false,
        getClienteError: action.data.error,
      };

    case CLIENTES_GET_CLIENTE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        getClienteError: null,
      };

    default:
      return state;
  }
}
